import { useState, useEffect } from "react";
import Links from "../../components/elements/Links.js";
import { checkSession, register, reset } from "../../slices/authSlice.js";
import { useSelector, useDispatch } from "react-redux";
import Message from "../../components/Message.js";
import Button from "../../components/elements/Button.js";
import Title2 from "../../components/elements/Title2.js";
import { useNavigate } from "react-router-dom";

const Register = () => {

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [nickname, setNickname] = useState("");
  const [orientation, setOrientation] = useState("");


  const dispath = useDispatch();
  const navigate = useNavigate();
  const {user, loading, error} = useSelector((state) => state.auth);

  const handleSubmit = (e) => {
    e.preventDefault();

    const userData  = {
      name,
      email,
      password,
      nickname,
      orientation,
      confirmPassword
    };
  
    dispath(register(userData));

  };

  useEffect(() => {
    if (user) {
      navigate("/Progress"); // Redireciona para a página de progress
    }
  }, [user, navigate]);

  useEffect(() =>{
    dispath(reset());
  }, [dispath]);


  return (

    <div className="bg-verde-oliva border-verde-musgo border-solid shadow-xl bg-opacity-85 sm:mx-auto sm:max-w-lg sm:rounded-lg content-center">
      <div className="mx-auto max-w-md">
        <Title2 tit={"Cadastro"} model={"def"}/>
        <div className="space-y-6 py-8 border-verde-musgo border-solid  text-base leading-7 text-gray-600">
          <form onSubmit={handleSubmit} className="max-w-sm mx-auto">
          <div className="mb-5">
            <label className="font-roboto block mb-2 text-sm font-bold text-gray-900 dark:text-white">Preencha seu nome completo</label>
            <input type="text" value={name || ""} onChange={(e) => setName(e.target.value)} className="text-xl font-special bg-dour-suave border border-dour-suave text-bordo-700 text-sm rounded-full focus:ring-cinza-cl focus:border-cinza-cl-500 block w-full p-2.5" required />
          </div>
          <div className="mb-5">
            <label className="font-roboto block mb-2 text-sm font-bold text-gray-900 dark:text-white">E-mail para login</label>
            <input type="email" value={email || ""} onChange={(e) => setEmail(e.target.value)} className="text-xl font-special bg-dour-suave border border-dour-suave text-bordo-700 text-sm rounded-full focus:ring-cinza-cl focus:border-cinza-cl-500 block w-full p-2.5" required />
          </div>
          <div className="mb-5">
            <label className="font-roboto block mb-2 text-sm font-bold text-gray-900 dark:text-white">Informe o apelido do seu personagem</label>
            <input type="text" value={nickname || ""} onChange={(e) => setNickname(e.target.value)} className="text-xl font-special bg-dour-suave border border-dour-suave text-bordo-700 text-sm rounded-full focus:ring-cinza-cl focus:border-cinza-cl-500 block w-full p-2.5" required />
          </div>
          <div className="mb-5">
            <label  className="font-roboto block mb-2 text-sm font-bold text-gray-900 dark:text-white">Informe sua senha</label>
            <input type="password" value={password || ""} onChange={(e) => setPassword(e.target.value)} className="text-xl font-special bg-dour-suave border border-dour-suave text-bordo-700 text-sm rounded-full focus:ring-cinza-cl focus:border-cinza-cl-500 block w-full p-2.5" required />
          </div>
          <div className="mb-5">
            <label className="font-roboto block mb-2 text-sm font-bold text-gray-900 dark:text-white">Confirme sua senha</label>
            <input type="password" value={confirmPassword || ""} onChange={(e) => setConfirmPassword(e.target.value)} className="text-xl font-special bg-dour-suave border border-dour-suave text-bordo-700 text-sm rounded-full focus:ring-cinza-cl focus:border-cinza-cl-500 block w-full p-2.5" required />
          </div>
          <div className="mb-5">
            <label className="font-roboto block mb-2 text-sm font-bold text-gray-900 dark:text-white">Escolha uma opção</label>
            <select onChange={(e) => setOrientation(e.target.value)} className="bg-dour-suave border border-dour-suave text-bordo-700 text-sm rounded-full focus:ring-cinza-cl focus:border-cinza-cl block w-full p-2.5" required>
              <option selected>Escolha a orientação do seu personagem</option>
              <option value="F">Feminino</option>
              <option value="M">Masculino</option>
            </select>
          </div>
          <div className="flex items-center justify-between">
          {!loading && <button type="submit" className="font-special font-semibold  transition ease-in-out delay-150 duration-300 hover:-translate-y-1 hover:scale-110 text-white bg-bordo hover:bg-bordo-600 focus:outline-none focus:ring-bege-cl-300 font-medium rounded-full text-sm w-full sm:w-40 px-5 py-2.5 text-center">Cadastrar</button>}
          {loading && <Button propertiesButton={{type: "submit", dis: "disabled", desc: "Aguarde..."}}/>}
          <p>
            <Links linkProp={{pag: "/Login", dsLink: "Já possuo uma conta", type: "D"}} />
          </p>
          </div>
          
          </form>
          {error && <Message msg={error} type="error" />}
        </div>
      </div>
    </div>
  )
}

export default Register